import { render, staticRenderFns } from "./AddFolderModal.vue?vue&type=template&id=52a36f66&"
import script from "./AddFolderModal.vue?vue&type=script&lang=js&"
export * from "./AddFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports